module.exports = __webpack_public_path__ + "img/bag_red_thumb.27c99f38.jpg";